export const REQUEST_ERROR_CODE = {
  CREDIT_ERROR: 100003,
};

/** 用户未登录 user 服务 */
export const USER_NOT_LOGIN_ACCOUNT = 100007;
